<template>
<div class="innerContent w100">
    <!-- Filtration values -->
    <b-button block href="#" v-b-toggle.accordion-1 variant="info" v-if="filtrationInfo.main.hasBackwash" class="btnAcordeon">{{ $t("messages.filtration") }}</b-button>
    <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
    <b-button-group id="mode" class="menuOpt tabs">
        <!-- MANUAL, AUTO, HEATING, SMART, INTEL -->
        <b-button class="optInt" style="margin:0px;" @click="filtrationInfo.filtration.mode = 0" :pressed="filtrationInfo.filtration.mode  === 0">MANUAL</b-button>
        <b-button class="optInt" style="margin:0px;" @click="filtrationInfo.filtration.mode = 1" :pressed="filtrationInfo.filtration.mode  === 1">AUTO</b-button>
        <b-button v-if="filtrationInfo.filtration.hasHeat" class="optInt" style="margin:0px;" @click="filtrationInfo.filtration.mode = 2" :pressed="filtrationInfo.filtration.mode  === 2">HEAT</b-button>
        <b-button v-if="filtrationInfo.filtration.hasSmart" class="optInt" style="margin:0px;" @click="filtrationInfo.filtration.mode = 3" :pressed="filtrationInfo.filtration.mode  === 3">SMART</b-button>
        <b-button v-if="filtrationInfo.filtration.hasHeat" class="optInt" style="margin:0px;" @click="filtrationInfo.filtration.mode = 4" :pressed="filtrationInfo.filtration.mode  === 4">INTEL</b-button>
    </b-button-group>

    <div v-if="filtrationInfo.filtration.mode === 0">
        <b-row class="mtop20">
            <b-col cols="4">
                <!-- Current status -->
                <p class="mr-10 lh-30 mb-0">{{ $t("messages.currentStatus") }}</p>
            </b-col>
            <b-col cols="8" class="text-left">
                <b-button-group id="mode" class="menuOpt">
                    <!-- OFF ON -->
                    <b-button class="optInt" style="margin:0px;" @click="filtrationInfo.filtration.status = 0 " :pressed="filtrationInfo.filtration.status === 0">{{ $t("messages.off") }}</b-button>
                    <b-button class="optInt" style="margin:0px;" @click="filtrationInfo.filtration.status = 1" :pressed="filtrationInfo.filtration.status === 1">{{ $t("messages.on") }}</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <div v-if="filtrationInfo.filtration.pumpType > 0">
            <b-row class="mt-5">
                <b-col cols="3" class="text-right">
                    <!-- Manual velocity -->
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.manVelocity") }} </p>
                </b-col>
                <b-col cols="9" class="text-left">
                    <el-select v-model="filtrationInfo.filtration.manVel" :placeholder=' $t("messages.select")'>
                        <el-option v-for="item in velocities" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
        </div>
    </div>
    <div v-if="filtrationInfo.filtration.mode === 1">
        <timers :info="filtrationInfo.filtration"></timers>
    </div>
    <!-- // HEATING -->
    <div v-if="filtrationInfo.filtration.mode === 2"> 
        <b-row class="w100 text-center" style="margin-top:20px;margin-bottom:0">
            <b-col cols="4">
                <!-- Clima -->
                <p class="left">Clima</p>
            </b-col>
              <b-col cols="8" class="left p0">
                        <b-button-group id="mode" class="menuOpt">
                    <!-- OFF ON -->
                            <b-button class="optInt" style="margin:0px;"  @click="filtrationInfo.filtration.heating.clima = 0" :pressed="filtrationInfo.filtration.heating.clima === 0">{{ $t("messages.off") }}</b-button>
                            <b-button class="optInt" style="margin:0px;"  @click="filtrationInfo.filtration.heating.clima = 1" :pressed="filtrationInfo.filtration.heating.clima=== 1">{{ $t("messages.on") }}</b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
            <b-row v-if="filtrationInfo.filtration.hasHeat===1" class="w100 text-left" style="margin-bottom:0">
                <b-col cols="4">
                    <!-- Temp -->
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.temperature") }}</p>
                </b-col>
                <b-col cols="8" class="left p0">
                    <number-input v-model.number="filtrationInfo.filtration.heating.temp" :min="0" :max="99" inline center controls size="small"></number-input>
                </b-col>
            </b-row>
            <b-row v-if="filtrationInfo.filtration.hasHeat===2" class="w100 text-left" style="margin-bottom:0">
                <b-col cols="4">
                    <!-- Temp. max. -->
                    <p class="left">{{ $t("messages.maxTemp") }}Cº</p>
                </b-col>
                <b-col cols="8" class="left p0">
                    <number-input v-model.number="filtrationInfo.filtration.heating.tempHi" :min="0" :max="50" inline center controls size="small"></number-input>
                </b-col>
                <b-col cols="4">
                    <!-- Temp. min. -->
                    <p class="left">{{ $t("messages.minTemp") }}Cº</p>
                </b-col>
                <b-col cols="8" class="left p0">
                    <number-input v-model.number="filtrationInfo.filtration.heating.temp" :min="0" :max="50" inline center controls size="small"></number-input>
                </b-col>

        </b-row>
        <timers :info="filtrationInfo.filtration"></timers>

    </div>
    <div v-if="filtrationInfo.filtration.mode === 3">
        <b-row class="w100 text-center" style="margin-top:20px;margin-bottom:0">
            <b-col cols="4">
                <!-- Freeze -->
                <p class="left">{{ $t("messages.freeze") }}</p>
            </b-col>
            <b-col cols="8" class="left p0">
                <b-button-group id="mode" class="menuOpt">
                    <!-- OFF ON -->
                    <b-button class="optInt" style="margin:0px;" @click="filtrationInfo.filtration.smart.freeze = 0" :pressed="filtrationInfo.filtration.smart.freeze === 0">{{ $t("messages.off") }}</b-button>
                    <b-button class="optInt" style="margin:0px;" @click="filtrationInfo.filtration.smart.freeze = 1" :pressed="filtrationInfo.filtration.smart.freeze === 1">{{ $t("messages.on") }}</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <b-row class="w100 text-left" style="margin-bottom:0">
            <b-col cols="4">
                <!-- Temp. min. -->
                <p class="left">{{ $t("messages.minTemp") }}Cº</p>
            </b-col>
            <b-col cols="8" class="left p0">
                <number-input v-model.number="filtrationInfo.filtration.smart.tempMin" :min="1" :max="50" inline center controls size="small"></number-input>
            </b-col>

            <b-col cols="4">
                <!-- Temp. max. -->
                <p class="left">{{ $t("messages.maxTemp") }}Cº</p>
            </b-col>
            <b-col cols="8" class="left p0">
                <number-input v-model.number="filtrationInfo.filtration.smart.tempHigh" :min="1" :max="50" inline center controls size="small"></number-input>
            </b-col>
        </b-row>

        <timers :info="filtrationInfo.filtration"></timers>
    </div>
    <div v-if="filtrationInfo.filtration.mode === 4">
        <b-row class="w100 text-center" style="margin-top:20px;margin-bottom:0">
            <b-col cols="4">
                <!-- Temp -->
                <p class="left">{{ $t("messages.temperature") }}.Cº</p>
            </b-col>
            <b-col cols="8" class="left p0">
                <number-input v-model.number="filtrationInfo.filtration.intel.temp" :min="1" :max="50" inline center controls size="small"></number-input>
            </b-col>

            <b-col cols="4">
                <!-- Time (hours) -->
                <p class="left">{{ $t("messages.time") }} ({{ $t("messages.hours") }})</p>
            </b-col>
            <b-col cols="8" class="left p0">
                <number-input v-model.number="intelTemp" :min="2" :max="23" inline center controls size="small"></number-input>
            </b-col>
           
            <b-col v-if="filtrationInfo.filtration.pumpType > 0" cols="4">
                <!-- Manual velocity -->
                <p class="mr-10 lh-30 mb-0">{{ $t("messages.velocity") }} </p>
            </b-col>
            <b-col v-if="filtrationInfo.filtration.pumpType > 0" cols="8" class="left p0">
                <el-select v-model="filtrationInfo.filtration.manVel" :placeholder=' $t("messages.select")'>
                    <el-option v-for="item in velocities" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </b-col>
        </b-row>
    </div>
    </b-collapse>

    <div v-if="filtrationInfo.main.hasBackwash">
        <!-- Backwash values -->
        <b-button block href="#" v-b-toggle.accordion-2 variant="info" class="btnAcordeon">{{ $t("messages.backwashValues") }}</b-button>
        <b-collapse id="accordion-2"  accordion="my-accordion" role="tabpanel">
            <b-button-group id="mode" class="menuOpt tabs">
                <!-- MANUAL AUTO -->
                <b-button class="optInt" style="margin:0px;" @click="filtrationInfo.backwash.mode = 0" :pressed="filtrationInfo.backwash.mode  === 0">{{ $t("messages.manual") }}</b-button>
                <b-button class="optInt" style="margin:0px;" @click="filtrationInfo.backwash.mode = 1" :pressed="filtrationInfo.backwash.mode  === 1">{{ $t("messages.auto") }}</b-button>
            </b-button-group>
            <div v-if="filtrationInfo.backwash.mode === 0">
                <b-row class="mtop20">
                    <b-col cols="3">
                        <!-- Status -->
                        <p class="mr-10 lh-30 mb-0">{{ $t("messages.status") }}</p>
                    </b-col>
                    <b-col cols="8" class="text-left">
                        <b-button-group id="mode" class="menuOpt">
                    <!-- OFF ON -->
                            <b-button class="optInt" style="margin:0px;" @click="filtrationInfo.backwash.status = 0 " :pressed="filtrationInfo.backwash.status === 0">{{ $t("messages.off") }}</b-button>
                            <b-button class="optInt" style="margin:0px;" @click="filtrationInfo.backwash.status = 1" :pressed="filtrationInfo.backwash.status === 1">{{ $t("messages.on") }}</b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
            </div>

            <b-row class="mtop10" v-if="filtrationInfo.backwash.mode === 1">
                <b-col cols="3" class="text-left">
                    <!-- Start At -->
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.startAt") }}:</p>
                </b-col>
                <b-col cols="3" class="text-left">
                    <el-time-picker format="HH:mm" v-model="startAt" value-format="HH:mm" start-:placeholder=' $t("messages.startTime")' end-:placeholder=' $t("messages.endTime")' :clearable=false>
                    </el-time-picker>
                </b-col>
            </b-row>


            <b-row class="w100 text-left" style="margin-bottom:0">
                <b-col cols="3">
                    <!-- Interval -->
                    <p class="left">{{ $t("messages.interval") }}</p>
                </b-col>
                <b-col cols="3" class="left p0">
                    <number-input v-model.number="filtrationInfo.backwash.interval" :min="1" :max="3600" inline center controls size="small"></number-input>
                </b-col>
            </b-row>

            <b-row class="mtop10" v-if="filtrationInfo.backwash.mode === 1">
                <b-col cols="3" class="text-left">
                    <p class="mr-10 lh-30 mb-0">{{ $t("messages.frequency") }}:</p>
                </b-col>
                <b-col cols="9">
                    <el-select v-model="backFrequency" :placeholder='$t("messages.select")'>
                        <el-option v-for="item in getFreqs" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </b-col>
            </b-row>
   
        </b-collapse>
    </div>
    <actions :has-changes="hasChanges" v-on:onSave="onSave" v-on:onCancel="onCancel"></actions>
</div>
</template>

<script>
import Timers from './utils/Timers.vue'
import Actions from "./utils/Actions";

export default {
    name: 'Filtration',
    components: {
        Timers,
        Actions
    },
    props: {
        poolId: Object
    },
    mounted() {
        let fresh = JSON.parse(JSON.stringify(this.poolId));
        this.filtrationInfo = fresh
        this.original = JSON.parse(JSON.stringify(fresh));
    },

    computed: {
        getFreqs(){
            return  [
                {
                    value: 86400,
                    label: this.$t("messages.daily")
                },
                {
                    value: 172800,
                    label: this.$t("messages.2daily")
                },
                {
                    value: 259200,
                    label: this.$t("messages.3daily")
                },
                {
                    value: 345600,
                    label: this.$t("messages.4daily")
                },
                {
                    value: 432000,
                    label: this.$t("messages.5daily")
                },
                {
                    value: 604800,
                    label: this.$t("messages.weekly")
                },
                {
                    value: 1209600,
                    label: this.$t("messages.2weekly")
                },
                {
                    value: 1814400,
                    label: this.$t("messages.3weekly")
                },
                {
                    value: 2419200,
                    label: this.$t("messages.4weekly")
                }
            ]
        },

        intelTemp: {
            get() {
                return parseInt(this.filtrationInfo.filtration.intel.time / 60)
            },
            set(val){
               this.filtrationInfo.filtration.intel.time = val * 60
            }
        },
        startAt:{
            get(){
                var start =  this.$moment.unix(this.filtrationInfo.backwash.startAt).utc().format("HH:mm")
                return start;  
            },
            set(newDate) { 
               this.filtrationInfo.backwash.startAt = this.$moment.duration(newDate).asSeconds()+1
            }
        },
        backFrequency:{
            get(){
                return this.filtrationInfo.backwash.frequency * 60;  
            },
            set(val) { 
                this.filtrationInfo.backwash.frequency = val / 60;  
            }
        },
    },
    data() {
        return {
            filtrationInfo: {
                'main':{
                    'hasBackwash': 0
                },
                'filtration':{
                    'mode': 0,
                    'status': 0
                },
                'backwash':{
                    'mode': 0,
                    'status': 0
                }
            },
            hasChanges: false,
            velocities: [{
                // Slow Medium High
                    value: 0,
                    label: this.$t("messages.slow")
                },
                {
                    value: 1,
                    label: this.$t("messages.medium")
                },
                {
                    value: 2,
                    label: this.$t("messages.high")
                }
            ]
        }
    },
    watch: {
        'filtrationInfo': {
            handler(value) {
                this.hasChanges = (JSON.stringify(value) === JSON.stringify(this.original)) ? false : true
            },
            deep: true
        }
    },
    methods: {
        onSave() {
            this.$emit('onSave',this.original, this.filtrationInfo, 'filtration');
            this.original = JSON.parse(JSON.stringify(this.filtrationInfo));
            this.hasChanges = false
        },
        onCancel() {
            this.filtrationInfo = JSON.parse(JSON.stringify(this.original));
            this.hasChanges = false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Filtration.vue